import {Swiper, Navigation, Pagination} from 'swiper/js/swiper.esm.js';
import {breakpoint} from './breakpoint'

// Install modules
Swiper.use([Navigation, Pagination]);

const customSwiper = (() => {
    const allSwipers = {};

    const init = () => {
        const itemsSwipers = document.querySelectorAll('[data-swiper]')

        itemsSwipers.forEach(swiper => {
            if(swiper.classList.contains('swiper-mobile') && breakpoint.large('up')) return;

            initSwiper(swiper)
        })
    };

    const initSwiper = (el) => {
        const breakpoints = {};
        const id = el.id;
        const itemsMd = el.getAttribute('data-swiper-md');
        const itemsLg = el.getAttribute('data-swiper-lg');
        const isPagination = el.querySelector('.swiper-pagination');
        let pagination = false;

        if (itemsMd)
            breakpoints[1024] = {
                slidesPerView: parseInt(itemsMd),
            }

        if (itemsLg)
            breakpoints[1400] = {
                slidesPerView: parseInt(itemsLg),
            }

        if (isPagination)
            pagination = {
                el: `#${id} .swiper-pagination`,
                type: 'bullets',
                clickable: true
            }

        allSwipers[id] = new Swiper(`#${id}`, {
            loop: false,
            slidesPerView: 'auto',
            centeredSlides: el.dataset.swiperCentered !== undefined,
            navigation: {
                nextEl: `#${id} .swiper-button-next`,
                prevEl: `#${id} .swiper-button-prev`,
                disabledClass: 'disabled'
            },
            pagination: pagination,
            on: {
                slideChange: function () {
                    if (this.slides.length === 0) return;

                    const prevSlide = this.slides[this.previousIndex];
                    const iframe = prevSlide.querySelector('iframe');

                    if (!iframe) return;

                    const frameSrc = iframe.getAttribute('src');

                    if (!frameSrc) return;

                    const embed = prevSlide.querySelector('.responsive-embed');
                    const newIframe = iframe.cloneNode(false);
                    newIframe.setAttribute('data-lazy-src', frameSrc);
                    newIframe.setAttribute('src', '');

                    iframe.remove();
                    embed.appendChild(newIframe);
                },
            },
        });
    };

    return {
        init: init
    };
})();

export {customSwiper}
